import { View } from 'components/View'
import React from 'react'
import getStyleComponentUtil from 'modules/component/utils/get-style'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'

/**
 * @param style
 * @param className
 * @param children
 * @param hasSmallVerticalPadding
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
export default function Block ({
  style,
  className,
  children,
  hasSmallVerticalPadding,
  ...rest
}) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  let padding
  if (hasSmallVerticalPadding && isSmallScreen) {
    padding = '1.5rem 2rem'
  } else if (hasSmallVerticalPadding && !isSmallScreen) {
    padding = '1.5rem 8rem'
  } else if (!hasSmallVerticalPadding && isSmallScreen) {
    padding = '4rem 2rem'
  } else {
    padding = '4rem 8rem'
  }

  const currentStyle = {
    padding
  }

  const styleToPass = getStyleComponentUtil(currentStyle, style)
  return (
    <View
      className={`block ${className || ''}`}
      centered
      style={styleToPass}
      data-bg={rest['data-bg']}
      {...rest}
    >
      {children}
    </View>
  )
}
